import { render } from "./LevelUpListItem.vue?vue&type=template&id=47b93a4a"
import script from "./LevelUpListItem.vue?vue&type=script&lang=js"
export * from "./LevelUpListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__